import { render, staticRenderFns } from "./search-template.vue?vue&type=template&id=aac3b29c"
import script from "./search-template.vue?vue&type=script&lang=js"
export * from "./search-template.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports